export const SET_DIMENSION = 'SET_DIMENSION';
export const SET_DRILL_PATH = 'SET_DRILL_PATH';

export const DRILL_DOWN = 'DRILL_DOWN';
export const SET_BREAKDOWN_DIMENSIONS = 'SET_BREAKDOWN_DIMENSIONS';

export function drillPathReducer(state = [], action) {
  switch (action.type) {
    case DRILL_DOWN:
      const { id, nextLevel } = action.payload;

      const drillPath = [
        ...state.slice(0, -1),
        {
          ...state.slice(-1).pop(),
          id,
        },
      ];

      if (nextLevel) {
        drillPath.push({
          type: nextLevel,
          id: '',
        });
      }

      return drillPath;
    case SET_DRILL_PATH:
      return action.payload;
    case SET_DIMENSION:
      return [...state.slice(0, -1), { type: action.payload, id: '' }];

    case SET_BREAKDOWN_DIMENSIONS:
      return [
        ...state,
        ...action.payload.map(({ breakdownId }) => ({
          type: breakdownId,
          id: '',
        })),
      ];
    default:
      return state;
  }
}
